export const getFileExtension = (fileName: string): string => {
  const fileNameParts = fileName.split('.');
  return fileNameParts.pop() ?? '';
};
